export default __webpack_public_path__ + "static/14-4d853bef4a248b477bae589db19c9c1c.webp";